import React, { useEffect } from "react";
import { withMobileDialog, Slide, Dialog, Paper } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import * as Actions from "app/store/actions/dialog.actions";
import Draggable from "react-draggable";
import { getDraggableDialogs } from "utils/get-environment-variables";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  paperScrollPaper: {
    height: "calc(100% - 64px)",
    overflowY: "hidden",
  },
});

const Transition = React.forwardRef((props, ref) => <Slide mountOnEnter unmountOnExit direction="up" ref={ref} {...props} />);

const isEnabledDraggableDialog = getDraggableDialogs() ?? false;
function PaperComponent(props) {
  if (!isEnabledDraggableDialog) return <Paper {...props} />;

  // Allow dialog to be dragged partially off-screen
  const MIN_VISIBLE_HEIGHT = 40;
  const MIN_VISIBLE_WIDTH = 80;

  const handleStop = (e, data) => {
    const { node } = data; // underlying Paper DOM element
    if (!node) return;
    const modalRect = node.getBoundingClientRect();
    const windowInnerWidth = window.innerWidth;
    const windowInnerHeight = window.innerHeight;
    let adjustX = 0;
    let adjustY = 0;
    // Prevent dragging upward off-screen: if top is negative, push dialog down so top = 0.
    if (modalRect.top < 0) {
      adjustY = -modalRect.top;
    }
    if (modalRect.right < MIN_VISIBLE_WIDTH) {
      adjustX = MIN_VISIBLE_WIDTH - modalRect.right;
    } else if (modalRect.left > windowInnerWidth - MIN_VISIBLE_WIDTH) {
      adjustX = (windowInnerWidth - MIN_VISIBLE_WIDTH) - modalRect.left;
    }
    if (modalRect.bottom < MIN_VISIBLE_HEIGHT) {
      adjustY = MIN_VISIBLE_HEIGHT - modalRect.bottom;
    } else if (modalRect.top > windowInnerHeight - MIN_VISIBLE_HEIGHT) {
      adjustY = (windowInnerHeight - MIN_VISIBLE_HEIGHT) - modalRect.top;
    }
    if (adjustX !== 0 || adjustY !== 0) {
      const hasXY = ("x" in data) && ("y" in data);
      if (hasXY) {
        const nextX = Number(data.x) + adjustX;
        const nextY = Number(data.y) + adjustY;
        node.style.transform = `translate(${nextX}px, ${nextY}px)`;
      }
    }
  };

  return (
    <Draggable
      handle="#form-dialog-title"
      cancel=".no-drag"
      onStop={handleStop}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const DefaultDialog = props => {
  const dispatch = useDispatch();
  const state = useSelector(({ dialog }) => dialog.defaultDialog);
  const options = useSelector(({ dialog }) => dialog.options);
  const fullHeight = useSelector(({ dialog }) => dialog.fullHeight);
  const classes = useStyles();

  const classValues = fullHeight ? { paperScrollPaper: classes.paperScrollPaper } : {};
  // Window capture wheel listener: forwards scroll to background target only when outside dialog paper.
  useEffect(() => {
    if (!state || !isEnabledDraggableDialog) return undefined;
    const getTarget = () => {
      const attrEl = document.querySelector('[data-scroll-container="main-content-section"]');
      return attrEl;
    };
    const wheelHandler = e => {
      const paperEl = document.querySelector(".MuiDialog-paper");
      if (paperEl && paperEl.contains(e.target)) {
        // Let modal scroll
        return;
      }
      const targetEl = getTarget();
      if (!targetEl) return;
      if (e.deltaY !== 0) {
        e.preventDefault();
        targetEl.scrollTop = Math.max(0, Math.min(targetEl.scrollTop + e.deltaY, targetEl.scrollHeight - targetEl.clientHeight));
      }
    };
    window.addEventListener("wheel", wheelHandler, { passive: false, capture: true });
    return () => window.removeEventListener("wheel", wheelHandler, { passive: false, capture: true });
  }, [state]);

  return (
    <Dialog
      PaperComponent={PaperComponent}
      fullScreen={props.fullScreen}
      fullWidth
      disableEnforceFocus // prevent loss focus when render dialog on top of dialog
      onClose={() => dispatch(Actions.closeDialog())}
      onExited={() => dispatch(Actions.resetDialog())}
      open={state}
      TransitionComponent={Transition}
      keepMounted
      classes={classValues}
      {...options}
    />
  );
};

export default withMobileDialog({ breakpoint: "xs" })(DefaultDialog);
